import { routesProfile } from '../consts'

export const MAX_PROJECT_TAG_LEN = 128

export const normalizeProjectTagForFilter = (tag: string): string | null => {
    const trimmed = tag.trim()
    if (!trimmed) {
        return null
    }

    const withoutHash = trimmed.replace(/^#+/, '')
    if (!withoutHash) {
        return null
    }

    const normalized = `#${withoutHash.toLowerCase()}`
    if (normalized.length > MAX_PROJECT_TAG_LEN) {
        return null
    }

    return normalized
}

export const buildProjectsByTagSearchPath = (tag: string): string => {
    const normalized = normalizeProjectTagForFilter(tag)
    if (!normalized) {
        return `/${routesProfile.PROJECTS.path}`
    }

    return `/${routesProfile.PROJECTS.path}?tag=${encodeURIComponent(normalized)}`
}
